import { Component, OnInit, Inject, Input, ViewChild } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogConfig,
  MatDialog,
} from '@angular/material/dialog';
import { NotesEnum } from 'src/app/services/notes/NotesEnum';
import { NoteConfirmationDialogComponent } from '../note-confirmation-dialog/note-confirmation-dialog.component';
import { UserDetailsService } from 'src/app/services/user-details.service';
import { MeetingNotesService } from 'src/app/services/meetingNotes/meeting-notes.service';
import { FormsModule, NgForm } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { MeetingNotesDTO } from 'src/app/dtos/MeetingNotesDTO';
import { ToastrService } from 'ngx-toastr';
import { NotesRefreshService } from 'src/app/services/notes/notesrefresh.service';
import { NewFeedbackGroupService } from 'src/app/services/new-feedback-group.service';

@Component({
  selector: 'app-notes-dialog',
  templateUrl: './notes-dialog.component.html',
  styleUrls: ['./notes-dialog.component.scss'],
})
export class NotesDialogComponent implements OnInit {
  @ViewChild('noteForm') noteForm!: NgForm;
  action: 'add' | 'edit' | 'view' = 'add';
  isViewMode = false;
  noteId: string;
  selectedDate: Date;
  noteSearch: string;
  noteTitle: string;
  noteDescription: string;
  NoteByList;
  noteby: any;
  hasHrRights: boolean = false;
  hasCmRights: boolean = false;
  directReporteeId: string;
  selectedYear: string;
  minDate: Date;
  maxDate: Date;
  isSubmitButtonDisabled: boolean = false;
  directReporteeList: any;
  hasSuperAdminRights: boolean = false;
  hasOnlyHrRights: boolean = false;
  shouldShowPntNotes: boolean = false;
  isSubmitting: boolean = false;
  isUserView: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    public userDetailsService: UserDetailsService,
    public meetingNotesService: MeetingNotesService,
    public toaster: ToastrService,
    private notesRefreshService: NotesRefreshService,
    public feedbackgroupservice: NewFeedbackGroupService
  ) {}

  ngOnInit(): void {
    this.action = this.data?.action || 'add';
    this.isViewMode = this.action === 'view';
    this.hasSuperAdminRights = this.userDetailsService.hasRole([
      'ROLE_SUPER_ADMIN',
    ]);
    this.hasOnlyHrRights =
      this.userDetailsService.hasRole(['ROLE_HUMAN_RESOURCE']) &&
      !this.hasSuperAdminRights;
    this.hasCmRights = this.userDetailsService.hasRole(['ROLE_CAREER_MANAGER']);
    this.directReporteeId = this.data.directReporteeId;
    this.selectedYear = this.data.selectedYear;
    this.minDate = new Date(parseInt(this.selectedYear), 0, 1); // Jan 1, 2025(selectedYear)
    this.maxDate = new Date(parseInt(this.selectedYear), 11, 31); // Dec 31, 2025(selectedYear)
    this.getAllReportee();
    this.setNoteByList();

    if (this.data.noteData) {
      const note = this.data.noteData;
      this.noteId = note.id;
      this.selectedDate = new Date(note.date);
      this.noteSearch = note.noteType;
      this.noteTitle = note.noteTitle;
      this.noteDescription = note.note;
    }
    if (this.data.isUserView) {
      this.isUserView = this.data.isUserView;
    }
  }

  getNoteTypeLabel(noteType: string): string {
    switch (noteType) {
      case NotesEnum.Career_Manager:
        return 'Career Manager Note';
      case NotesEnum.PnT_Buddy:
        return 'PnT Buddy Note';
      case NotesEnum.Capability_Lead:
        return 'Capability Lead Note';
      default:
        return 'View Note';
    }
  }

  getAllReportee(): void {
    this.feedbackgroupservice
      .getdirectreporteebyyear(this.selectedYear)
      .subscribe((res) => {
        this.directReporteeList = res.body;
        const isReporteeOfHr = this.directReporteeList?.some(
          (reportee: any) => reportee.userId === this.directReporteeId
        );
        this.shouldShowPntNotes =
          this.hasSuperAdminRights || (this.hasOnlyHrRights && !isReporteeOfHr);

        this.setNoteByList();
      });
  }

  dateFilter = (date: Date | null): boolean => {
    const today = new Date();
    const currentDate = date || new Date();
    currentDate.setHours(0, 0, 0, 0);

    // Return false if the date is in the future
    return currentDate <= today;
  };

  openConfirmationDialog(): void {
    if (this.noteForm && this.noteForm.dirty) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      dialogConfig.autoFocus = true;
      dialogConfig.width = '450px';
      dialogConfig.height = '200px';
      dialogConfig.data = {
        title: 'Discard Note',
        message: 'Do you want to discard the changes?',
      };
      dialogConfig.panelClass = 'confirm-discard-dialog';

      const dialogRef = this.dialog.open(
        NoteConfirmationDialogComponent,
        dialogConfig
      );

      dialogRef.afterClosed().subscribe((result) => {
        if (result === true) {
          this.dialogRef.close(); // Close the Note dialog
        }
      });
    } else {
      this.dialogRef.close(); // No changes made, close directly
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }

  ifOverflow(e) {
    return e.scrollWidth > e.clientWidth;
  }

  setNoteByList() {
    this.NoteByList = Object.entries(NotesEnum)
      .filter(([key, value]) => {
        if (key === 'PnT_Buddy') {
          return this.shouldShowPntNotes;
        }
        return true;
      })
      .map(([key, value]) => ({ key, value }));
  }

  onDateChange(event: any): void {
    this.selectedDate = event.value;
    //this.selectedDate = this.formatDate(this.selectedDate);
  }

  private formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  Submit(form: NgForm) {
    // this.isSubmitButtonDisabled = true;
    // if (
    //   !this.selectedDate ||
    //   !this.noteSearch ||
    //   !this.noteTitle ||
    //   !this.noteDescription
    // ) {
    //   return;
    // }
    if (form && !form.valid) {
      return;
    }

    this.isSubmitButtonDisabled = true;
    this.isSubmitting = true;

    const payload: MeetingNotesDTO = {
      noteType: this.noteSearch,
      year: this.selectedDate?.getFullYear().toString(),
      noteTitle: this.noteTitle,
      note: this.noteDescription,
      date: this.formatDate(this.selectedDate),
      userId: this.directReporteeId,
    };

    if (this.action === 'edit') {
      this.meetingNotesService
        .updateMeetingNote(this.noteId, payload)
        .subscribe({
          next: () => {
            this.toaster.success('Successfully updated', 'Updated');
            this.notesRefreshService.triggerRefresh();
            this.dialogRef.close(true);
            this.isSubmitButtonDisabled = false;
            this.isSubmitting = false;
          },
          error: (err) => {
            console.error('Error updating note:', err);
            this.toaster.error('Failed to update note');
            this.isSubmitButtonDisabled = false;
            this.isSubmitting = false;
          },
        });
    } else {
      this.meetingNotesService.createMeetingNote(payload).subscribe({
        next: () => {
          this.toaster.success('Successfully saved', 'Saved');
          this.notesRefreshService.triggerRefresh();
          this.dialogRef.close(true);
          this.isSubmitButtonDisabled = false;
          this.isSubmitting = false;
        },
        error: (err) => {
          console.error('Error saving note:', err);
          this.toaster.error('Failed to save note');
          this.isSubmitButtonDisabled = false;
          this.isSubmitting = false;
        },
      });
    }
  }
}
